var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"chart-1 d-flex align-center justify-center"},[(_vm.loading)?_c('Loader'):_c('div',{attrs:{"id":"chart-1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }